import { render } from "./index.vue?vue&type=template&id=4b58427a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4b58427a&scoped=true&lang=scss"

import exportComponent from "E:\\work\\高大\\dealer-pda\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b58427a"]])

export default __exports__